export const CP = 'CP';
export const OTHER = 'OTHER';
export const SELF = 'SELF';
